import { ButtonInfo } from "../items";

// 依頼文書用権限情報model
export class WorkflowDocumentPermissions {
  // 登録
  public register: ButtonInfo;

  // 一時保存
  public registerTemporary: ButtonInfo;

  // 印刷
  public print: ButtonInfo;

  // 登録＆印刷
  public registerAndPrint: ButtonInfo;

  // 編集
  public edit: ButtonInfo;

  // 承認
  public approve: ButtonInfo;

  // 差戻し
  public sendBack: ButtonInfo;

  // 発行
  public publish: ButtonInfo;

  // 登録・発行
  public writeAndPublish: ButtonInfo;

  // 終了
  public finish: ButtonInfo;

  // 終了取消
  public cancelFinish: ButtonInfo;

  // コストなし終了
  public finishWithoutCost: ButtonInfo;

  // 伝達事項（表示＠文書編集開始時）
  public nextMessageShow: ButtonInfo;

  // 伝達事項（表示＠文書登録時）
  public nextMessageRegister: ButtonInfo;

  // 差戻しコメント（表示＠文書編集開始時）
  public backMessageShow: ButtonInfo;

  // 差戻しコメント（表示＠差戻し時）
  public backMessageRegister: ButtonInfo;
}
